
import XInput from 'vux/src/components/x-input/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import Divider from 'vux/src/components/divider/index.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import DatetimeRange from 'vux/src/components/datetime-range/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {fetch,promptMessage,baseUrl } from '@/api/dataHandling';
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import axios from 'axios';
import Vue from 'vue';
import {getken} from '@/api/getToken';
import {urlConfig} from '@/api/urlConfig';
import $ from 'jquery';
Vue.use(ConfirmPlugin);
export default {
data(){
return{
startDate:'',
oneTitle:'',
twoTitle:'',
formData:{
scheduleDate:'',
expectedTime:[],
diagItemIdStr:'',
diagItemNameStr:'',
parentEnName:'MZZYZL'
},
demo1:'',
demo2:'',
one:[],
schedule:{},
two:[],
bedData:[],
projectName:'',
submitdisabled:false,
expectedTimereadonly:true,
expectedTimeOptions: [],
}
},
components: {
XInput,Flexbox,Divider, FlexboxItem,Cell,Checker, CheckerItem,dateFormat,XHeader,Group, PopupRadio,DatetimeRange, Datetime,XButton,PopupPicker,Popup
},
directives: {
TransferDom
},
watch:{

},
methods:{
twobedchange(){
if(this.demo2.toString() !=''){
this.twosubmitData = {
schedule:{
orderLargeClassDm:this.two[this.demo2].parentItemId,
orderLargeClassName:this.two[this.demo2].parentItemName,
orderSmallClassDm:this.two[this.demo2].childItemId,
orderSmallClassName:this.two[this.demo2].childItemName,
scheduledDate:this.formData.scheduleDate,
shiftTime:this.two[this.demo2].shiftTime,
schedulItemId:this.two[this.demo2].shiftTimeId,
},
scheduleOrderList:[]
};
let twodiagItemIdStr = this.two[this.demo2].diagItemIdStr.split(',');
for(let i=0;i<twodiagItemIdStr.length;i++){
for(let j=0;j<this.projectData.length;j++){
if(twodiagItemIdStr[i] == this.projectData[j].itemId){
this.twosubmitData.scheduleOrderList.push({
"appItemId":twodiagItemIdStr[i],
"appItemType":'05',
"orderId":this.projectData[j].applicationNo,
"payStatus":this.projectData[j].payStatus,
"appItem":this.projectData[j].itemName
})
}
}
}
}else{
this.twosubmitData ={};
}
},
bedchange(){

if(this.demo1.toString() !=''){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.onesubmitData = {
schedule:{

orderLargeClassDm:this.one[this.demo1].parentItemId,
orderLargeClassName:this.one[this.demo1].parentItemName,
orderSmallClassDm:this.one[this.demo1].childItemId,
orderSmallClassName:this.one[this.demo1].childItemName,
scheduledDate:this.formData.scheduleDate,
shiftTime:this.one[this.demo1].shiftTime,
schedulItemId:this.one[this.demo1].shiftTimeId,
},
scheduleOrderList:[]
};
let twobedArry = [];
this.twobedItemStr = [];
let twobedItemId = [];
let maxtime = this.one[this.demo1].shiftTime.substring(this.one[this.demo1].shiftTime.indexOf('-')+1);
let localId = this.formData.diagItemIdStr.split(',');
let timeID = this.one[this.demo1].diagItemIdStr.split(',');

let txtStr =',';
for(let i =0;i<timeID.length;i++){
txtStr = txtStr + timeID[i] +',';
}
for(let j =0;j<localId.length;j++){
if(txtStr.indexOf(','+localId[j]+',')== -1){
for(let z=0;z<this.projectData.length;z++){
if(localId[j] == this.projectData[z].itemId){
twobedArry.push(this.projectData[z]);
}
}


}else{
for(let z=0;z<this.projectData.length;z++){
if(localId[j] == this.projectData[z].itemId){
this.onesubmitData.scheduleOrderList.push({
"appItemId":localId[j],
"appItemType":'05',
"orderId":this.projectData[z].applicationNo,
"payStatus":this.projectData[z].payStatus,
"appItem":this.projectData[z].itemName
})
}

}


}
}
for(let w=0;w<twobedArry.length;w++){
this.twobedItemStr.push(twobedArry[w].itemName);
twobedItemId.push(twobedArry[w].itemId);
}
if(localId.length != timeID.length){
let parmdata = new URLSearchParams();
parmdata.append("scheduleDate",this.formData.scheduleDate);
parmdata.append("expectedTime",maxtime);
parmdata.append("diagItemIdStr",twobedItemId.toString());
parmdata.append("diagItemNameStr",this.twobedItemStr.toString());
parmdata.append("parentEnName",this.formData.parentEnName);
this.demo2 ='';
this.two =[];
this.twoTitle ='';
fetch('post',urlConfig.reservationgetbednum,parmdata).then(response => {
this.two = response;
this.twoTitle = this.two[0].diagItemNameStr;
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.showPopup = true;
}).catch(error => {
promptMessage('提示: ' +error);
this.$store.commit('updateLoadingStatus',{isLoading:false});
});


}else{
this.$store.commit('updateLoadingStatus',{isLoading:false});
};


}else{
this.demo2 ='';
this.two =[];
this.twoTitle ='';
this.onesubmitData ={};
this.twosubmitData ={};
}
},
expectedTimeChange(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
if(this.formData.expectedTime.toString()){
let parmdata = new URLSearchParams();
parmdata.append("scheduleDate",this.formData.scheduleDate);
parmdata.append("expectedTime",this.formData.expectedTime.toString());
parmdata.append("diagItemIdStr",this.formData.diagItemIdStr);
parmdata.append("diagItemNameStr",this.formData.diagItemNameStr);
parmdata.append("parentEnName",this.formData.parentEnName);
this.demo1 ='';
this.one =[];
this.oneTitle ='';
fetch('post',urlConfig.reservationgetbednum,parmdata).then(response => {
this.one = response;
this.oneTitle = this.one[0].diagItemNameStr;
this.getdiagItemIdStrArry = this.one[0].diagItemIdStr.split(',');
this.$store.commit('updateLoadingStatus',{isLoading:false});

}).catch(error => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示: ' +error);
})
}

},
dateConfirm(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.formData.expectedTime =[];
this.one =[];
axios.post( baseUrl + urlConfig.reservationgettimes + '?scheduleDate=' + this.formData.scheduleDate).then(response => {
this.expectedTimeOptions = [[]];

for(let i=0;i<response.data.length;i++){
this.expectedTimeOptions[0].push(response.data[i].expectedTime);
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(function (error) {
promptMessage('提示: ' +error);

});
},
expectedTimeChooseClick(){
if(this.formData.scheduleDate == ""){
this.expectedTimereadonly = true;
this.$vux.toast.show({
type:'text',
text: '请选择预约日期'
});
}else {
this.expectedTimereadonly = false;
}

},
submint(){

this.submitData = [];
for(let i in this.formData){
if(this.formData[i] == '') {
this.$vux.toast.show({
type: 'text',
text: '请选择预约日期和时间段'
});
return false;
}
}
if(this.demo1.toString() ==''){
this.$vux.toast.show({
type: 'text',
text: '请选择床位！'
});
return false;
}
if(this.projectNameArry.length >this.getdiagItemIdStrArry.length){   //二级床位选择未选择
if(this.demo2.toString() ==''){
this.$vux.toast.show({
type: 'text',
text: '请选择'+this.twobedItemStr.toString()+'的床位！'
});
return false;
}else{
this.submitData.push(this.onesubmitData,this.twosubmitData);
}

}else{
this.submitData.push(this.onesubmitData);
}
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
for(let j in this.schedule){
for(let i =0;i<this.submitData.length;i++){
this.submitData[i]['schedule'][j] = this.schedule[j];
this.submitData[i].schedule.createTime = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
this.submitData[i].schedule.regNum = this.submitData[i].scheduleOrderList.length;
}
}
let _this = this;
fetch('post',urlConfig.reservationZZsave+'?dataListStr='+encodeURI(JSON.stringify(this.submitData))).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示','保存成功！',function(){
_this.$router.push({path:'/reservationIndex?openid='+_this.$route.query.openid,query:{tabindex:1,personInfoId:_this.personInfoId,type:'zy'}});
});
}).catch(error => {
promptMessage('提示','保存失败');
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.submitdisabled = false;
})
},
},
mounted(){
console.log(JSON.parse(localStorage.getItem('project')));
this.projectData =  JSON.parse(localStorage.getItem('project'));
this.projectNameArry = [];
this.projectIDArry = [];
for(let i=0;i<this.projectData.length;i++){
this.projectNameArry.push(this.projectData[i].itemName);
this.projectIDArry.push(this.projectData[i].itemId);
}
this.projectName = this.projectNameArry.toString().replace(/,/g,'+');
this.startDate = dateFormat(new Date(), 'YYYY-MM-DD');
this.formData.diagItemNameStr = this.projectNameArry.toString();
this.formData.diagItemIdStr = this.projectIDArry.toString();
let _this = this;
this.personInfoId = this.$route.query.personInfoId;
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
});
let patientBasic = JSON.parse(localStorage.getItem('patientBasic'));

this.schedule = {
"personInfoId":patientBasic.personInfoId,
"identityNo":patientBasic.identityNo,
"patientName":patientBasic.patientName,
"sXbDm":patientBasic.sXbDm,
"phoneNumber":patientBasic.phoneNumber,
"scheduledStatusDm":"1",
"createUserId":"72fef3267fb980812709",
"scheduleSource":"10",
};
}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/reservationChineseMedical.vue